import isEqual from 'lodash/isEqual';
import React from 'react';

import ErrorComponent from '../generic/Error';
import Loading from '../generic/Loading';
import getDisplayName from '../utils/get-display-name';
import RequestComponent from './RequestComponent';

export default function withResolved({
  query: queryFn,
  deriveQueryArgs: queryArgsFn = () => undefined,
  as = 'resolved',
  loadingProps = { className: 'p-3' },
}) {
  return WrappedComponent => {
    class WithResolvedComponent extends RequestComponent {
      componentDidMount() {
        this.args = queryArgsFn(this.props);
        this.load(this.args);
      }

      componentDidUpdate() {
        const newArgs = queryArgsFn(this.props);
        if (!isEqual(newArgs, this.args)) {
          this.args = newArgs;
          this.load(this.args);
        }
      }

      load(args) {
        return this.trackRequest(queryFn(args));
      }

      render() {
        const { result, error } = this.state;

        if (this.isLoading()) {
          return <Loading {...loadingProps} />;
        }

        if (error) {
          return <ErrorComponent error={error} />;
        }

        if (result) {
          const other = {
            [as]: result,
            reload: () => {
              this.load(this.args);
            },
          };

          return <WrappedComponent {...this.props} {...other} />;
        }

        return <Loading {...loadingProps} />;
      }
    }

    WithResolvedComponent.displayName = `withResolved(${
      queryFn.apiName || queryFn.name
    } for ${getDisplayName(WrappedComponent)})`;

    return WithResolvedComponent;
  };
}
